import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.invoiceTransporter.title, 'Transporter'),
  transporterName: () => __(translations.invoiceTransporter.transporterName, 'Name'),
  transporterPrice: () => __(translations.invoiceTransporter.transporterPrice, 'Price'),

};
